import { render, staticRenderFns } from "./EMelderComponentMeldungenChatRightMessage.vue?vue&type=template&id=cba08bf2&scoped=true"
import script from "./EMelderComponentMeldungenChatRightMessage.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenChatRightMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba08bf2",
  null
  
)

export default component.exports